import { get } from '@/axios'

export interface IGroupCheckInGroupsRequest {
  group_ids: string[]
}

export interface IGroupCheckInGroupsResponse {
  list: { group_id: string; in_group: boolean }[]
}

export const getGroupCheckInGroups = async (params: IGroupCheckInGroupsRequest) => {
  const response = await get<IGroupCheckInGroupsResponse>(`/imApi/group/checkInGroups`, params, {
    'Cache-Control': 'no-cache',
  })

  return response
}
